<template>
  <b-modal
    id="view_security_question"
    title="MODIFICAR PERGUNTA DE SEGURANÇA"
    hide-footer
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    :hide-header-close="loading"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <label-required-field label="Enunciado" />
          <b-input ref="autofocus" v-model="statement" />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            :disabled="loading"
            class="v-primary ml-1"
            @click="$bvModal.hide('view_security_question')"
          >
            <i class="fa fa-arrow-left mr-1" /> VOLTAR
          </v-btn>
          <v-btn :disabled="loading" class="v-danger ml-1" @click="remove">
            <i class="fa fa-close mr-1" /> APAGAR
          </v-btn>
          <v-btn :disabled="loading" type="submit" class="v-success ml-1">
            <i class="fa fa-check mr-1" /> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../../components/ToastNotification";
import api from "../../../services/api";
import ErrorsMessages from "../../components/ErrorsMessages.vue";
import LabelRequiredField from "../../components/LabelRequiredField.vue";
import WarningRequiredFields from "../../components/WarningRequiredFields.vue";
export default {
  name: "ViewSecurityQuestion",
  components: { LabelRequiredField, WarningRequiredFields, ErrorsMessages },
  props: {
    question: Object,
  },
  data() {
    return {
      errors: [],
      loading: false,

      id: "",
      statement: "",
    };
  },
  watch: {
    question: function (new_question) {
      if (!new_question) return;
      this.id = new_question.id;
      this.statement = new_question.statement;
      this.$bvModal.show("view_security_question");
    },
  },
  methods: {
    async evOnShow() {
      this.errors = [];
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnHide() {},
    async evOnSubmit() {
      this.loading = true;

      try {
        const data = { id: this.id, statement: this.statement };
        const response = await api.patch("/default/security-question", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$emit("updated");
          this.$bvModal.hide("view_security_question");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async remove() {
      this.loading = true;

      try {
        const params = { id: this.id };
        const response = await api.delete("/default/security-question", {
          params,
        });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$emit("updated");
          this.$bvModal.hide("view_security_question");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>